/* istanbul ignore file */
export var useCalendarBadges = function () {
    // native only hook
};
